import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const ProfitTargetForm = forwardRef(({year, target, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={target}
      type="target"
      fieldsComponent={Fields}
      onSave={useCallback(({id, break_even, good, over_achieve}) => (
        services.profitTarget.saveTarget({
          ...(id ? {id} : {}),
          year,
          break_even,
          good,
          over_achieve,
        })
      ), [services, year])}
      onSaved={onSaved}
    />
  );
});

export default ProfitTargetForm;
